export const styles = {
  wrapper: 'inline-flex text-gray-2',
  icon: 'w-8 h-8 p-1 mx-1 cursor-pointer hover:text-white',
  volumeButton: 'w-8 h-8 mx-1 bg-white text-black hover:bg-red',
};
